<template>
  <v-list-item
    v-if="
      useBelajarWajibStore().isAuthorized && Object.keys(dataPegawai).length > 0
    "
  >
    <v-list-item-title class="text-capitalize">{{
      !dataPegawai.nama ? "" : dataPegawai.nama.toLowerCase()
    }}</v-list-item-title>
    <v-list-item-subtitle>{{ dataPegawai.nip || "" }}</v-list-item-subtitle>
    <template v-slot:prepend>
      <v-avatar :image="avatar"></v-avatar>
    </template>
  </v-list-item>
</template>
<script>
export default {
  data() {
    return {
      avatar: "",
    };
  },
  watch: {
    profile(val) {
      if (Object.keys(val).length > 0) {
        this.updateAvatar();
      }
    },
  },
  computed: {
    dataPegawai() {
      return useBelajarWajibStore().dataPegawai || {};
    },
    profile() {
      return useBelajarWajibStore().profile || {};
    },
  },
  mounted() {
    this.updateAvatar();
  },
  methods: {
    updateAvatar() {
      const { fileName } = this.profile;
      const baseUrl = useRuntimeConfig().public.apiBelajarWajib;
      const time = new Date().getTime();
      this.avatar = fileName
        ? `${baseUrl}/image/file/image/${fileName}?v=${time}`
        : "https://placehold.co/200x200/eeeeee/eeeeee";
    },
  },
};
</script>
